<template>
    <v-container grid-list-md fluid :style="{ height: containerHeight }">
        <template v-if="currentUser.profile && isAuthorized">
            <v-row no-gutters class="my-3 justify-center">
                <v-col cols="2" v-if="!isAutonomousUser && !selectMode">
                    <v-menu open-on-hover offset-y location="bottom">
                        <template #activator="{ props }">
                            <v-btn-primary
                                v-bind="props"
                                @click="openDocumentWizard()"
                                elevation="0"
                                block
                                id="AddDocumentBtn"
                                v-if="!$vuetify.display.mobile"
                                :disabled="!!auditCheck"
                                data-cy="documentsTable-add"
                            >
                                Ajouter
                            </v-btn-primary>
                        </template>

                        <v-list nav>
                            <v-list-item
                                v-if="
                                    currentUser.profile.configuration.document.importPurchaseInvoice
                                "
                                @click="startUpload('PURCHASE_INVOICE')"
                                title="Importer un fichier d'achat"
                            >
                                <template #append>
                                    <v-icon size="x-small">$fa-chevron-right</v-icon>
                                </template>
                            </v-list-item>
                            <v-list-item
                                v-if="currentUser.profile.configuration.document.importSalesInvoice"
                                @click="startUpload('SALES_INVOICE')"
                                title="Importer un fichier de vente"
                            >
                                <template #append>
                                    <v-icon size="x-small">$fa-chevron-right</v-icon>
                                </template>
                            </v-list-item>
                            <v-list-item
                                two-line
                                v-if="
                                    currentUser.profile.configuration.document
                                        .importMultiSalesInvoice
                                "
                                @click="activeSaleInvoices = true"
                                title="Importer un fichier de ventes"
                                subtitle="fichier .csv"
                            >
                                <template #append>
                                    <v-icon size="x-small">$fa-chevron-right</v-icon>
                                </template>
                            </v-list-item>
                            <!-- <v-list-item
                                v-if="
                                    currentUser.profile.configuration.document.importSalesInvoice &&
                                    selectedCompany.profile &&
                                    selectedCompany.profile.stripeManual
                                "
                                @click="stripeDialog = true"
                                title="Importer un fichier Stripe"
                            >
                                <template #append>
                                    <v-icon size="x-small">$fa-chevron-right</v-icon>
                                </template>
                            </v-list-item> -->
                            <v-list-item
                                v-if="
                                    currentUser.profile.configuration.document
                                        .importPurchaseInvoice && declareSalesInvoices
                                "
                                @click="startUpload('CURRENT_ACCOUNT')"
                                title="Importer une facture en compte courant"
                            >
                                <template #append>
                                    <v-icon size="x-small">$fa-chevron-right</v-icon>
                                </template>
                            </v-list-item>
                            <v-list-item
                                v-if="
                                    currentUser.profile.configuration.document
                                        .importPurchaseInvoice && !declareSalesInvoices
                                "
                                @click="startUpload('OPERATOR_ACCOUNT')"
                                title="Importer une facture en compte de l'exploitant"
                            >
                                <template #append>
                                    <v-icon size="x-small">$fa-chevron-right</v-icon>
                                </template>
                            </v-list-item>
                            <v-list-item
                                v-if="
                                    currentUser.profile.configuration.document
                                        .importPurchaseInvoice &&
                                    selectedCompany.solution === 'MANAGEMENT'
                                "
                                @click="startUpload('PAY_SLIP')"
                                title="Importer un fichier de fiche de paie"
                            >
                                <template #append>
                                    <v-icon size="x-small">$fa-chevron-right</v-icon>
                                </template>
                            </v-list-item>
                            <v-list-item
                                v-if="
                                    currentUser.profile.configuration.document.importPurchaseInvoice
                                "
                                @click="startUpload('MISCELLANEOUS')"
                                title="Importer un fichier divers"
                            >
                                <template #append>
                                    <v-icon size="x-small">$fa-chevron-right</v-icon>
                                </template>
                            </v-list-item>
                            <v-list-item
                                v-if="
                                    currentUser.profile.configuration.document.importPurchaseInvoice
                                "
                                @click="startUpload('UNKNOWN')"
                                title="Importer un fichier à découper"
                            >
                                <template #append>
                                    <v-icon size="x-small">$fa-chevron-right</v-icon>
                                </template>
                            </v-list-item>
                            <!-- <v-list-item
                                v-if="currentUser.profile.configuration.document.importPurchaseInvoice"
                                @click="widgetDialog = true"
                            >
                                <v-list-item-title>Graph Custom</v-list-item-title>
                                <template #append>
                                    <v-icon  size=“x-small”>$fa-chevron-right</v-icon>
                                </template>
                            </v-list-item> -->
                            <v-list-item
                                v-if="isAccountingUser"
                                @click.stop="uploadDocumentsFromMailDialog = true"
                                title="A partir des mails"
                            >
                                <template #append>
                                    <v-icon size="x-small">$fa-chevron-right</v-icon>
                                </template>
                            </v-list-item>
                            <v-list-item @click="subscriptionsDialog = true" title="Abonnement">
                                <template #append>
                                    <v-icon size="x-small">$fa-chevron-right</v-icon>
                                </template>
                            </v-list-item>
                            <v-list-item
                                v-if="currentUser.profile.configuration.bankTransaction.import"
                                @click="openBankImportMain()"
                                title="Importer des relevés bancaires"
                            >
                                <template #append>
                                    <v-icon size="x-small">$fa-chevron-right</v-icon>
                                </template>
                            </v-list-item>
                            <v-list-item
                                v-if="isAccountingUser"
                                @click.stop="openLoanPage()"
                                title="Emprunt"
                            >
                                <template #append>
                                    <v-icon size="x-small">$fa-chevron-right</v-icon>
                                </template>
                            </v-list-item>
                            <!-- <v-list-item
                                v-if="isAccountingUser && localEnv === 'dev'"
                                @click.stop="startUpload('LOAN')"
                                title="Emprunt OCR"
                            >
                                <template #append>
                                    <v-icon size="x-small">$fa-chevron-right</v-icon>
                                </template>
                            </v-list-item> -->
                            <v-list-item
                                v-if="isAccountingUser"
                                @click.stop="openLeasingPage()"
                                title="Crédit-Bail"
                            >
                                <template #append>
                                    <v-icon size="x-small">$fa-chevron-right</v-icon>
                                </template>
                            </v-list-item>
                            <!-- <v-list-item
                                @click="openDocumentWizard()"
                                title="Afficher plus d'option"
                            >
                                <template #append>
                                    <v-icon size="x-small">$fa-chevron-right</v-icon>
                                </template>
                            </v-list-item> -->
                            <v-divider v-if="extensionsDialog.length" />
                            <v-list-item
                                v-for="ext of extensionsDialog"
                                @click="
                                    () => {
                                        widgetDialog = true;
                                        activeExtension = ext;
                                    }
                                "
                                :key="ext.id"
                                :title="ext.name"
                            >
                                <template #append>
                                    <v-icon size="x-small">$fa-chevron-right</v-icon>
                                </template>
                            </v-list-item>
                            <!-- <v-list-item
                                v-if="isAccountingUser && currentUser.profile.configuration.document.importPurchaseInvoice && currentUser.profile.configuration.accounting.write"
                                @click="miscellaneousOperationDialog = true"
                            >
                                <v-list-item-title>OD</v-list-item-title>
                                <v-list-item-icon>
                                    <v-icon  size=“x-small”>$fa-chevron-right</v-icon>
                                </v-list-item-icon>
                            </v-list-item> -->
                        </v-list>
                    </v-menu>
                </v-col>
                <v-col :cols="$vuetify.display.mobile ? '12' : showTotal ? '6' : '8'" class="pl-2">
                    <oss-filter-bar
                        mode="document"
                        v-model:type="type"
                        v-model:text="search"
                        v-model:tags="documentTags"
                        v-model:startDate="beginDate"
                        v-model:endDate="endDate"
                        v-model:status="documentStatus"
                        v-model:declaredStatus="declaredStatus"
                        v-model:thirdPartyCompanyName="thirdPartyCompanyName"
                        :minPrice="minAmount"
                        @update:minPrice="
                            documentType === 'PURCHASE_INVOICE'
                                ? (maxAmount = -$event + '')
                                : (minAmount = $event + '')
                        "
                        :maxPrice="maxAmount"
                        @update:maxPrice="
                            documentType === 'PURCHASE_INVOICE'
                                ? (minAmount = -$event + '')
                                : (maxAmount = $event + '')
                        "
                        :limitMinPrice="
                            documentType === 'PURCHASE_INVOICE'
                                ? -maxDocumentAmount
                                : minDocumentAmount
                        "
                        :limitMaxPrice="
                            documentType === 'PURCHASE_INVOICE'
                                ? -minDocumentAmount
                                : maxDocumentAmount
                        "
                        :types-list="
                            documentTypes.map((type) => {
                                return { value: type, text: formatType(type) };
                            })
                        "
                        :status-list="
                            allDocumentStatus.map((type) => {
                                return { value: type, text: formatStatus(type) };
                            })
                        "
                        :companyId="selectedCompany.id"
                        v-model:auditCheck="auditCheck"
                        :auditChecks="documentType !== 'MAIL' ? auditChecks : null"
                        v-model:partitionTagId="partitionTagId"
                        :partitionTags="partitionTags"
                        data-cy="DocumentsTable-filterBar"
                    />
                </v-col>
                <v-col cols="2" v-if="showTotal" class="pl-2">
                    <v-text-field
                        outlined
                        readonly
                        :model-value="'Total : ' + newCommonFormatCurrency(amountSum, undefined)"
                    >
                    </v-text-field>
                </v-col>

                <v-col v-if="!$vuetify.display.mobile" cols="2" class="d-flex justify-end">
                    <AuditCheckAlertButton
                        v-if="auditCheckDocumentsWithAnomalyCount > 0"
                        :count="auditCheckDocumentsWithAnomalyCount"
                        auditCheckType="Document"
                        @auditCheckAlertButtonClicked="onAuditCheckAlertButtonClicked"
                    />
                    <AuditCheckDocumentDialog
                        v-model="shouldAuditCheckDocumentDialogBeVisible"
                        :auditChecks="auditCheckDocumentsWithAnomaly"
                        :companyId="selectedCompany.id"
                    />
                    <TutorialButtonDialog :starterComponents="'DocumentsTable;'" />
                </v-col>
            </v-row>
            <div
                style="position: fixed; right: 60px; bottom: 60px; z-index: 10"
                v-if="$vuetify.display.mobile"
            >
                <v-speed-dial
                    v-model="mobileDocumentDial"
                    location="top center"
                    transition="slide-y-transition"
                >
                    <template v-slot:activator="{ props }">
                        <!-- @click="startUpload('PURCHASE_INVOICE')" -->
                        <v-btn
                            fab
                            style="float: right; box-shadow: 10px 10px 7px rgba(0, 0, 0, 0.06)"
                            v-show="!importDocument"
                            size="small"
                            :icon="mobileDocumentDial ? '$oss-close' : '$add'"
                            v-bind="props"
                        >
                        </v-btn>
                    </template>
                    <v-btn
                        key="1"
                        size="small"
                        fab
                        color="primary"
                        style="float: right; box-shadow: 10px 10px 7px rgba(0, 0, 0, 0.06)"
                        v-show="!importDocument"
                        @click="openDocumentWizard()"
                        icon="$add"
                    >
                    </v-btn>
                    <v-btn
                        key="2"
                        size="small"
                        fab
                        color="primary"
                        style="float: right; box-shadow: 10px 10px 7px rgba(0, 0, 0, 0.06)"
                        v-show="!importDocument"
                        @click="startUpload('PURCHASE_INVOICE')"
                        icon="$note-frais"
                    >
                    </v-btn>
                </v-speed-dial>
            </div>
            <template v-if="!$vuetify.display.mobile">
                <v-data-table-server
                    :headers="headers"
                    :items="documents"
                    :page="pagination.page"
                    :sort-by="pagination.sortBy"
                    :sort-desc="pagination.descending"
                    :items-per-page="pagination.rowsPerPage"
                    :items-length="pagination?.totalItems || 0"
                    :items-per-page-options="[5, 10, 25]"
                    :loading="loading"
                    class="table rounded-lg"
                    hide-default-footer
                    fixed-header
                    :height="selectMode ? '60vh' : '76vh'"
                    style="min-width: 1150px"
                    v-if="documentType !== 'MAIL'"
                >
                    <template #headers="{ columns: headers }">
                        <tr>
                            <th :colspan="1" style="width: 64px">
                                <div class="d-flex align-center justify-center">
                                    <v-checkbox
                                        v-model="isAllSelected"
                                        :indeterminate="isIndeterminate"
                                        color="primary"
                                        density="compact"
                                        hide-details
                                    />
                                </div>
                            </th>
                            <th :colspan="headers.length" style="padding-left: 0">
                                <v-row no-gutters class="flex-nowrap">
                                    <v-col
                                        cols="6"
                                        class="d-flex align-center space-x-2 flex-grow-1 flex-shrink-0"
                                    >
                                        <v-btn-ternary
                                            @click="dialogChangeThirdPartyCompanyDocument = true"
                                            :disabled="!onlyPurchasesSelected"
                                            v-if="isAccountingUser && !selectMode"
                                        >
                                            Fournisseur
                                        </v-btn-ternary>
                                        <v-btn-ternary
                                            @click="dialogChangeThirdPartyCompanyDocument = true"
                                            :disabled="!onlySalesSelected"
                                            v-if="isAccountingUser && !selectMode"
                                            class="ml-2"
                                        >
                                            Client
                                        </v-btn-ternary>
                                        <DocumentMultipleAnalysis
                                            :is-enable="documentMultipleAnaysisPossible"
                                            :documents="selectedDocuments"
                                        />
                                        <v-btn-ternary
                                            @click="multiValidationDialog = true"
                                            :disabled="!onlyToValidateOKSelected"
                                            v-if="
                                                isAccountingUser &&
                                                enableMultiValidation &&
                                                !selectMode
                                            "
                                            class="ml-2"
                                        >
                                            Valider
                                        </v-btn-ternary>
                                        <multiple-free-tagging
                                            :company="selectedCompany"
                                            :company-tags="allCompanyTags"
                                            :selected-documents="selectedDocuments"
                                            @selected-tags="onMultiTagguingApplied"
                                            v-if="!selectMode"
                                        />
                                        <v-menu offset-y v-if="!selectMode">
                                            <template v-slot:activator="{ props }">
                                                <v-btn-icon
                                                    icon="$dots_vertical"
                                                    v-bind="props"
                                                    :loading="menuLoading"
                                                />
                                            </template>
                                            <v-list>
                                                <v-list-item
                                                    v-if="showActionIgnoreDuplicates"
                                                    @click="ignoreSelectedDuplicatedDocuments"
                                                    :disabled="!isActionIgnoreDuplicatesEnabled"
                                                >
                                                    <v-list-item-title>
                                                        Ignorer les doublons sélectionnés
                                                    </v-list-item-title>
                                                    <template #append>
                                                        <v-icon size="small">$oss-close</v-icon>
                                                    </template>
                                                </v-list-item>
                                                <v-list-item
                                                    v-if="showActionHideOrShowIgnoredDuplicates"
                                                    @click="toggleShowIgnoredAuditChecks"
                                                >
                                                    <v-list-item-title>
                                                        {{
                                                            !showIgnoredAuditChecks
                                                                ? "Afficher les doublons ignorés"
                                                                : "Masquer les doublons ignorés"
                                                        }}
                                                    </v-list-item-title>
                                                    <template #append>
                                                        <v-icon
                                                            v-if="!showIgnoredAuditChecks"
                                                            size="small"
                                                        >
                                                            $oss-eye
                                                        </v-icon>
                                                        <v-icon v-else size="small">
                                                            $oss-eye-slash
                                                        </v-icon>
                                                    </template>
                                                </v-list-item>
                                                <v-divider
                                                    v-if="
                                                        showActionIgnoreDuplicates ||
                                                        showActionHideOrShowIgnoredDuplicates
                                                    "
                                                />
                                                <v-list-item @click="showTag = !showTag">
                                                    <v-list-item-title>
                                                        {{
                                                            showTag
                                                                ? "Cacher les étiquettes"
                                                                : "Afficher les étiquettes"
                                                        }}
                                                    </v-list-item-title>
                                                    <template #append>
                                                        <v-icon size="small">$oss-eye</v-icon>
                                                    </template>
                                                </v-list-item>
                                                <v-list-item
                                                    :disabled="disabledDownload"
                                                    @click="startDownloadFile"
                                                    v-if="isAccountingUser"
                                                >
                                                    <v-list-item-title>
                                                        Télécharger
                                                    </v-list-item-title>
                                                    <template #append>
                                                        <v-icon size="small">$oss-download</v-icon>
                                                    </template>
                                                </v-list-item>
                                                <v-divider v-if="isAccountingUser" />
                                                <v-list-item
                                                    v-if="!displayDeletePermanentlyButton"
                                                    :disabled="disabledDelete"
                                                    color="error"
                                                    @click="dialogDeleteSelectedDocument = true"
                                                    :active="!disabledDelete"
                                                >
                                                    <v-list-item-title>Supprimer</v-list-item-title>
                                                    <template #append>
                                                        <v-icon size="small">$delete</v-icon>
                                                    </template>
                                                </v-list-item>
                                                <v-list-item
                                                    v-if="displayDeletePermanentlyButton"
                                                    :disabled="disabledDeletePermanently"
                                                    color="red"
                                                    @click="
                                                        dialogDeletePermanentlySelectedDocument = true
                                                    "
                                                    :active="!disabledDeletePermanently"
                                                >
                                                    <v-list-item-title>
                                                        Supprimer définitivement
                                                    </v-list-item-title>
                                                    <template #append>
                                                        <v-icon size="small">$delete</v-icon>
                                                    </template>
                                                </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </v-col>
                                    <v-col
                                        cols="6"
                                        class="d-flex justify-end align-center flex-grow-0 flex-shrink-1 space-x-1"
                                    >
                                        <v-select
                                            v-model="sortBy"
                                            :items="sortByList"
                                            style="font-size: 0.75rem; width: min-content"
                                            hide-details
                                            item-value="key"
                                            item-title="text"
                                            label="Trier par"
                                            outlined
                                            return-object
                                            density="compact"
                                        />
                                        <v-select
                                            v-model="pagination.rowsPerPage"
                                            :items="[5, 10, 25]"
                                            hide-details
                                            outlined
                                            style="font-size: 0.75rem; width: min-content"
                                            label="Lignes par page"
                                            @update:model-value="checkMaximumPage()"
                                            density="compact"
                                        />
                                        <span style="white-space: nowrap">
                                            {{ (pagination.page - 1) * pagination.rowsPerPage + 1 }}
                                            -
                                            {{
                                                (pagination.page - 1) * pagination.rowsPerPage +
                                                pagination.rowsPerPage
                                            }}
                                            de {{ pagination.totalItems }}
                                        </span>
                                        <div>
                                            <v-btn-prev
                                                @click="pagination.page--"
                                                size="x-small"
                                                :disabled="pagination.page === 1"
                                            />
                                            <v-btn-next
                                                @click="pagination.page++"
                                                size="x-small"
                                                :disabled="nextPageDisabled"
                                            />
                                        </div>
                                    </v-col>
                                </v-row>
                            </th>
                        </tr>
                    </template>

                    <template v-slot:no-data>Aucune facture déclarée</template>
                    <template v-slot:item="props">
                        <tr
                            style="cursor: pointer"
                            :data-cy="'documentTable-document-' + props.item.id"
                            @click="
                                selectMode
                                    ? displayDocumentBeforeSelect(props.item)
                                    : openDocument(props.item)
                            "
                        >
                            <td class="text-center" style="width: 64px">
                                <div class="d-flex align-center justify-center">
                                    <v-checkbox
                                        @click.stop="
                                            selectMode
                                                ? addSelectedAuditCheckDocument(props.item)
                                                : addSelectedDocument(props.item.id)
                                        "
                                        color="primary"
                                        hide-details
                                        :ripple="false"
                                        :model-value="
                                            selectMode
                                                ? isAuditCheckDocumentSelected(props.item.id)
                                                : isSelected(props.item.id)
                                        "
                                    >
                                    </v-checkbox>
                                </div>
                            </td>
                            <td class="pl-2 pr-2 text-center">
                                <b v-if="!isAutonomousUser">{{
                                    $t("document.shortType." + props.item.type || "UNKNOWN")
                                }}</b>
                            </td>

                            <td
                                :class="{
                                    'pl-0': true,
                                    'pr-2': true,
                                    'pb-1':
                                        currentUser.profile &&
                                        currentUser.profile.configuration.tag.write &&
                                        props.item.type !== 'EXPENSE_REPORT_DOCUMENT',
                                    'text-center': getDocumentTitle(props.item) === '-',
                                }"
                            >
                                <template v-if="showTag && props.item.accountingLineTags">
                                    <v-chip-tag
                                        :ripple="false"
                                        v-for="(tag, index) of props.item.accountingLineTags"
                                        :key="index"
                                        class="text mr-1"
                                    >
                                        <span :style="'color:' + labelTextColor + ';'">{{
                                            tag.name
                                        }}</span>
                                    </v-chip-tag>
                                </template>
                                <template v-if="getDocumentTitle(props.item) !== '-'">
                                    <span class="body-1">{{
                                        getDocumentTitle(props.item, false)
                                    }}</span>
                                    <v-icon
                                        color="secondary"
                                        v-if="props.item.uniqueExport && props.item.uniqueExport.id"
                                        size="small"
                                        location="end"
                                        >$oss-already-downloaded</v-icon
                                    >
                                </template>
                                <template v-else>
                                    <v-icon color="primary" size="large">$dot</v-icon>
                                </template>
                                <FreeTag
                                    v-if="
                                        showTag &&
                                        currentUser.profile.configuration.tag.write &&
                                        props.item.type !== 'EXPENSE_REPORT_DOCUMENT' &&
                                        !selectMode
                                    "
                                    :companyTags="allCompanyTags"
                                    :document="props.item"
                                    @focus="onFreeTagFocus"
                                    @blur="onFreeTagBlur"
                                    @tagRuleApplyOnThirdPartyCompany="refetchDocuments"
                                    :key="props.item.id"
                                />
                            </td>
                            <!-- <td class="px-0 text-center" v-else>
                                <v-icon color="primary" size="large">$dot</v-icon>
                            </td> -->
                            <td class="pl-0 pr-2 text-center" v-if="props.item.invoiceNumber">
                                {{ props.item.invoiceNumber }}
                            </td>
                            <td
                                style="cursor: pointer; text-align: center"
                                class="px-0 text-center"
                                v-else
                            >
                                <v-icon color="primary" size="large">$dot</v-icon>
                            </td>
                            <td class="px-0 text-center" v-if="props.item.date">
                                {{ formatDate(props.item.date) }}
                            </td>
                            <td style="text-align: center" class="px-0 text-center" v-else>
                                <v-icon color="primary" size="large">$dot</v-icon>
                            </td>
                            <td
                                :style="
                                    grossAmountSignedAsValue(props.item) < 0 ? 'color:red;' : ''
                                "
                                class="px-0 text-right"
                            >
                                <template
                                    v-if="
                                        props.item.type === 'BANK_STATEMENT' ||
                                        props.item.type === 'MISCELLANEOUS'
                                    "
                                >
                                    <v-icon color="primary" size="large">$dot</v-icon>
                                </template>
                                <template v-else>
                                    {{
                                        newCommonFormatCurrency(
                                            grossAmountSigned(props.item),
                                            undefined,
                                        )
                                    }}
                                </template>
                            </td>
                            <td class="px-0 text-center">
                                {{ dateFromNow(props.item.updatedAt) }}
                            </td>
                            <td
                                v-if="
                                    currentUser.profile &&
                                    currentUser.profile.configuration.document.statusDisplay &&
                                    selectedCompany.solution !== 'MANAGEMENT'
                                "
                                class="pr-1 text-center"
                            >
                                <template v-if="props.item.type === 'MISCELLANEOUS'">
                                    <v-icon color="primary" size="large">$dot</v-icon>
                                </template>
                                <v-chip
                                    class="ma-2"
                                    :color="statusColor(props.item)"
                                    v-else
                                    variant="outlined"
                                    label
                                    size="small"
                                >
                                    {{ statusTooltip(props.item) }}
                                </v-chip>
                                <v-chip
                                    class="ma-2"
                                    color="green"
                                    variant="outlined"
                                    label
                                    size="small"
                                    v-if="props.item.vatDeclaration"
                                    v-tooltip="declaredDateTooltip(props.item)"
                                >
                                    Déclaré
                                </v-chip>
                            </td>
                            <td
                                v-if="
                                    currentUser.profile &&
                                    currentUser.profile.configuration.document.statusDisplay &&
                                    selectedCompany.solution !== 'MANAGEMENT'
                                "
                                class="pr-1 text-center"
                                @click.stop="openDocument(props.item, true)"
                            >
                                <v-tooltip v-if="reconciliationIcon(props.item)" location="start">
                                    <template v-slot:activator="{ props: ttProps }">
                                        <v-icon
                                            v-bind="ttProps"
                                            :color="reconciliationColor(props.item)"
                                            size="small"
                                        >
                                            {{ reconciliationIcon(props.item) }}
                                        </v-icon>
                                    </template>
                                    <span>{{ reconciliationTooltip(props.item) }}</span>
                                </v-tooltip>
                            </td>
                            <td
                                v-if="
                                    currentUser.profile &&
                                    currentUser.profile.configuration.document.statusDisplay &&
                                    selectedCompany.solution !== 'MANAGEMENT'
                                "
                                class="pr-1 text-center"
                                @click.stop="openDocument(props.item, true)"
                            >
                                <v-tooltip
                                    v-if="
                                        !!props.item.original || documentInZtillReceipt(props.item)
                                    "
                                    location="start"
                                >
                                    <template v-slot:activator="{ props }">
                                        <v-icon v-bind="props" color="magic" size="small">
                                            $oss-file
                                        </v-icon>
                                    </template>
                                    <span>Un fichier est relié a ce document</span>
                                </v-tooltip>
                            </td>
                        </tr>
                    </template>
                </v-data-table-server>
                <v-data-table-server
                    :header="mailHeaders"
                    :items="mails"
                    :page="pagination.page"
                    :sort-by="pagination.sortByMail"
                    :sort-desc="pagination.descending"
                    :items-per-page="pagination.rowsPerPage"
                    :items-length="pagination.totalItems"
                    :items-per-page-options="[5, 10, 25]"
                    :loading="loading"
                    class="table rounded-lg"
                    fixed-header
                    hide-default-footer
                    :height="selectMode ? '60vh' : '76vh'"
                    style="min-width: 1150px"
                    v-else
                >
                    <template #headers="{ columns: mailHeaders }">
                        <tr>
                            <th :colspan="headers.length" style="padding-left: 0">
                                <v-row no-gutters class="flex-nowrap">
                                    <v-col
                                        cols="12"
                                        class="d-flex justify-end align-center space-x-0 flex-grow-1 flex-shrink-0"
                                    >
                                        <v-select
                                            v-model="sortByMail"
                                            :items="sortByListMail"
                                            hide-details
                                            item-value="key"
                                            item-title="text"
                                            label="Trier par"
                                            outlined
                                            return-object
                                            density="compact"
                                            style="max-width: 22%"
                                        />
                                        <v-select
                                            v-model="pagination.rowsPerPage"
                                            :items="[5, 10, 25]"
                                            hide-details
                                            outlined
                                            label="Lignes par page"
                                            @update:model-value="checkMaximumPage()"
                                            density="compact"
                                            style="max-width: 16%"
                                        />
                                        <span style="white-space: nowrap">
                                            {{ (pagination.page - 1) * pagination.rowsPerPage + 1 }}
                                            -
                                            {{
                                                (pagination.page - 1) * pagination.rowsPerPage +
                                                pagination.rowsPerPage
                                            }}
                                            de {{ pagination.totalItems }}
                                        </span>
                                        <v-btn-prev
                                            @click="pagination.page--"
                                            :disabled="pagination.page === 1"
                                        />
                                        <v-btn-next
                                            @click="pagination.page++"
                                            :disabled="nextPageDisabled"
                                        />
                                    </v-col>
                                </v-row>
                            </th>
                        </tr>
                    </template>
                    <template v-slot:no-data>Aucune mail trouvé</template>
                    <template v-slot:item="{ item }">
                        <tr
                            style="cursor: pointer"
                            @click="openMail(item)"
                            :data-cy="'documentTable-document-' + item"
                        >
                            <td class="px-0 text-center" v-if="item.date">
                                {{ formatDate(item.date) }}
                            </td>
                            <td @click="openMail(item)" class="px-0 text-center" v-else>
                                <v-icon color="primary" size="large">$dot</v-icon>
                            </td>
                            <td class="px-0 text-left">
                                {{ "&#xc0; " + mailTo(item.to) }}
                            </td>
                            <td class="pr-0 text-left">
                                {{ "De " + mailFrom(item.from) }}
                            </td>
                            <td class="pr-0 text-left">
                                {{ otherCompany(item) }}
                            </td>

                            <td class="pr-2" v-if="item.subject !== '-'">
                                <div
                                    style="
                                        min-width: 100px;
                                        max-width: 600px;
                                        overflow: hidden;
                                        white-space: nowrap;
                                        text-overflow: ellipsis;
                                    "
                                >
                                    <span class="font-weight-bold">{{ item.subject }}</span>
                                    {{ item.text }}
                                </div>
                            </td>
                            <td @click="openMail(item)" class="px-0 text-center" v-else>
                                <v-icon color="primary" size="large">$dot</v-icon>
                            </td>
                        </tr>
                    </template>
                </v-data-table-server>
            </template>
            <template v-else>
                <v-row no-gutters style="max-height: calc(100vh - 226px); overflow-y: auto">
                    <v-col cols="12">
                        <v-card
                            v-if="!documents.length && !loading && firstRequestDone"
                            class="default_card large"
                            elevation="0"
                        >
                            <v-card-title style="text-align: center !important" primary-title
                                >Aucun justificatif trouvé</v-card-title
                            >
                            <v-card-text
                                style="text-align: center"
                                v-if="
                                    currentUser.profile.configuration.document.importSalesInvoice ||
                                    currentUser.profile.configuration.document.importPurchaseInvoice
                                "
                            >
                                <v-btn
                                    class="btn_card"
                                    rounded
                                    @click="openDocumentWizard()"
                                    size="small"
                                    >Ajouter</v-btn
                                >
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12" class="py-1" v-for="document in documents" :key="document.id">
                        <v-card
                            elevation="0"
                            class="pa-2"
                            style="border-radius: 8px; min-height: 40px"
                            @click="openDocument(document)"
                        >
                            <v-row no-gutters style="flex-wrap: nowrap">
                                <v-col class="mobile flex-grow-1 flex-shrink-0">
                                    {{
                                        getDocumentTitle(document, false) !== "-"
                                            ? getDocumentTitle(document, false)
                                            : formatType(document.type)
                                    }}
                                </v-col>
                                <v-col
                                    :class="
                                        'mobile flex-grow-0 flex-shrink-1 d-flex justify-end ' +
                                        getAmountClass(document)
                                    "
                                    v-if="
                                        newCommonFormatCurrency(
                                            grossAmountSigned(document),
                                            undefined,
                                        )
                                    "
                                >
                                    {{
                                        newCommonFormatCurrency(
                                            grossAmountSigned(document),
                                            undefined,
                                        )
                                    }}
                                </v-col>
                            </v-row>
                            <v-row no-gutters style="flex-wrap: nowrap">
                                <v-col class="mobile flex-grow-0 flex-shrink-1">
                                    <v-icon color="secondary" size="small" location="start"
                                        >$oss-calendar</v-icon
                                    >
                                    {{ formatDateMobile(document.date) }}
                                </v-col>
                                <v-col
                                    :class="
                                        'flex-grow-1 flex-shrink-1 d-flex justify-end align-center ' +
                                        'text-' +
                                        statusColor(document)
                                    "
                                >
                                    <v-badge
                                        dot
                                        inline
                                        :color="statusColor(document)"
                                        class="mr-1"
                                        floating
                                    />
                                    {{ statusTooltip(document) }}
                                    <v-icon
                                        v-if="!!document.original"
                                        color="magic"
                                        size="small"
                                        location="end"
                                    >
                                        $oss-file
                                    </v-icon>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                    <v-col
                        :cols="$vuetify.display.mobile ? '12' : '10'"
                        class="d-flex px-3 justify-center"
                        v-if="
                            documents &&
                            documents.length &&
                            documents.length < pagination.totalItems
                        "
                    >
                        <oss-card :skeleton="true" v-intersect="onIntersect">
                            <template #left />
                        </oss-card>
                    </v-col>
                </v-row>
            </template>
            <oss-dialog
                v-model="dialogChooseDownload"
                title="Télécharger le document"
                max-width="800px"
            >
                Voulez-vous télécharger le document original ou marqué (numéro de pièce + horodaté)
                ?
                <template v-slot:actions>
                    <v-row no-gutters>
                        <v-col cols="6" class="pr-2">
                            <v-btn-primary
                                rounded
                                block
                                @click="
                                    dialogChooseDownload = false;
                                    downloadFile(true);
                                "
                                size="x-large"
                                >Original</v-btn-primary
                            >
                        </v-col>
                        <v-col cols="6" class="pl-2">
                            <v-btn-primary
                                rounded
                                block
                                @click="
                                    dialogChooseDownload = false;
                                    downloadFile(false);
                                "
                                size="x-large"
                                >Marqué</v-btn-primary
                            >
                        </v-col>
                    </v-row>
                </template>
            </oss-dialog>
        </template>
        <DocumentWizardDialog
            v-if="importDocument"
            v-model="importDocument"
            :companyId="selectedCompany.id"
            :documentType="documentTypeToUpload"
            :inGlobalStep="inGlobalStep"
            @files-uploaded="refetchDocuments()"
            @startMiscellaneousOperation="
                importDocument = false;
                miscellaneousOperationDialog = true;
            "
            @startMiscellaneous="startUpload('MISCELLANEOUS')"
            @startLoanOcr="startUpload('LOAN')"
            @close="inGlobalStep = ''"
        />
        <oss-dialog v-model="stripeDialog" title="Importation Stripe" width="80vw">
            <ImportStripe
                :companyId="selectedCompany.id"
                @close="stripeDialog = false"
                @importDone="onImportDone"
            >
            </ImportStripe>
        </oss-dialog>
        <!-- <AccountingItemEdition
            v-model="miscellaneousOperationDialog"
            :companyId="selectedCompany.id"
            @upsert="refetchDocuments()"
            v-if="miscellaneousOperationDialog"
        ></AccountingItemEdition> -->
        <oss-dialog
            v-model="miscellaneousOperationDialog"
            :actions="actionsMiscellaneousOperation"
            width="90vw"
        >
            <AccountingItemEdition2
                v-if="miscellaneousOperationDialog"
                :companyId="selectedCompany.id"
                @upsert="refetchDocuments()"
                :actions="actionsMiscellaneousOperation"
            />
        </oss-dialog>
        <oss-dialog
            v-model="dialogDeleteSelectedDocument"
            title="Supprimer des documents"
            validTitle="Oui, je suis sûr(e)"
            valid-class="error"
            @valid="deleteDocuments"
            width="800px"
        >
            <h4 class="text-center">
                Voulez-vous supprimer {{ selectedDocumentIds.length }} document{{
                    selectedDocumentIds.length === 1 ? "" : "s"
                }}
                ?
            </h4>
        </oss-dialog>
        <oss-dialog
            v-model="dialogDeletePermanentlySelectedDocument"
            title="Supprimer des documents définitivement"
            @valid="deleteDocuments(false)"
            width="800px"
        >
            <div class="text-center">
                <h4>
                    Voulez-vous supprimer définitivement
                    {{ selectedDocumentIds.length }} document{{
                        selectedDocumentIds.length === 1 ? "" : "s"
                    }}
                    ?
                </h4>
            </div>
        </oss-dialog>
        <oss-dialog
            v-model="multiValidationDialog"
            title="Validation des justificatifs"
            @valid="multiValidateDocuments"
            width="800px"
        >
            <div class="text-center">
                <h4>
                    Voulez-vous valider {{ selectedDocumentIds.length }} justificatif{{
                        selectedDocumentIds.length === 1 ? "" : "s"
                    }}
                    ?
                </h4>
            </div>
        </oss-dialog>
        <oss-dialog
            v-model="dialogChangeThirdPartyCompanyDocument"
            :title="
                'Modifier le ' +
                (onlySalesSelected ? 'client' : 'fournisseur') +
                ' ' +
                (selectedDocumentIds.length === 1
                    ? 'du document'
                    : `des ${selectedDocumentIds.length} documents`)
            "
            @valid="changeThirdPartyCompany"
            :validDisabled="!newThirdPartyCompany || !newThirdPartyCompany.id"
            width="800px"
        >
            <company-table
                v-model="newThirdPartyCompany"
                :showGenericCompany="false"
                :showConsumerCompanies="onlySalesSelected"
                :showCustomerCompanies="onlySalesSelected"
                :showSupplierCompanies="onlyPurchasesSelected"
                :showExistingCompanies="false"
                :showNewCompanies="true"
                :parentCompanyId="selectedCompany.id"
                :wizardMode="true"
            />
        </oss-dialog>
        <oss-dialog
            v-model="widgetDialog"
            :hide-valid="true"
            :title="activeExtension.name || ''"
            width="70vw"
        >
            <div style="height: 60vh" class="pa-1" v-if="widgetDialog">
                <oss-widget-embedder v-bind="activeExtension" @close="widgetDialog = false" />
            </div>
        </oss-dialog>
        <SalesInvoice
            v-model="activeSaleInvoices"
            v-if="activeSaleInvoices"
            @salesInvoiceImported="imported()"
        />
        <upload-documents-from-mail
            v-model="uploadDocumentsFromMailDialog"
            v-if="uploadDocumentsFromMailDialog"
            @attachment-uploaded="refetchDocuments"
        />
        <Subscriptions
            v-model="subscriptionsDialog"
            v-if="subscriptionsDialog"
            :companyId="selectedCompany.id"
            @subscription-upserted="refetchDocuments"
        >
        </Subscriptions>
        <ImportBankMain v-model="importBankDialog" @bankTransactionImported="refresh()" />
    </v-container>
</template>

<script lang="ts">
import DocumentWizardDialog from "./DocumentWizardDialog.vue";
import ImportBankMain from "../bank/import-bank/ImportBankMain.vue";
import SalesInvoice from "../SalesInvoice.vue";
import FreeTag from "../tag/FreeTag.vue";
import MultipleFreeTagging from "../tag/MultipleFreeTagging.vue";
import ImportStripe from "../ImportStripe.vue";
import OssFilterBar from "../ossComponents/ossFilterBar.vue";
import AccountingItemEdition2 from "../accounting/accountingItem/Edition.vue";
import ossCompanySelector from "../ossComponents/ossCompanySelector.vue";
import companyTable from "../admin/CompaniesTable.vue";
import UploadDocumentsFromMail from "./UploadDocumentsFromMail.vue";
import OssWidgetEmbedder from "../ossComponents/ossWidgetEmbedder.vue";
import Subscriptions from "../subscriptions/Subscriptions.vue";
import TutorialButtonDialog from "../tutorial/TutorialButtonDialog.vue";
import DocumentMultipleAnalysis from "../../components/document/DoumentMultipleAnalysis.vue";
import AuditCheckDocumentDialog from "./AuditCheckDocumentDialog.vue";
import AuditCheckAlertButton from "../audit/AuditCheckAlertButton.vue";

import { Apollo } from "@/decorators";

import {
    getCommonDocumentQueryFromALVariables,
    getCommonMailQueryVariables,
} from "../../services/graphqlServices";
import { getChatStatus } from "../../services/chatServices";
import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";
import {
    getAuditCheckDocuments,
    upsertAuditCheckResultIfNeeded,
} from "@/services/audit/auditCheckDocument.services";

import DOCUMENTS_FILTER_QUERY from "../../graphql/document/FilterDocuments.gql";
import MAILS_FILTER_QUERY from "../../graphql/mail/FilterMails.gql";
import ACCOUNTING_LINES from "../../graphql/document/FilterFocumentFromAccountingLines.gql";
import UPDATE_MANY_DOCUMENTS_STATUS from "../../graphql/document/UpdateManyDocumentsStatus.gql";
import EXTENSIONS_LIST from "../../graphql/extension/ExtentionsContext.gql";

import { AuditCheckDocumentKey } from "@/views/document/enum/AuditCheckDocumentKey.enum";
import { AuditCheckDocumentName } from "@/views/document/enum/AuditCheckDocumentName.enum";
import { AuditCheckDocumentResult } from "@/types/auditCheck.types";

import colors from "vuetify/util/colors";
import getEnv from "../../env";
import { DialogAction } from "@/services/dialogAction";
import { Component, toNative, Prop, Watch } from "vue-facing-decorator";
import emitter from "@/services/emitter";
import { Documents } from "./Documents";

import { isInsideAccountingClosing } from "../../services/accountingPeriods";

const env = getEnv();

@Component({
    components: {
        DocumentWizardDialog,
        ImportBankMain,
        SalesInvoice,
        FreeTag,
        ImportStripe,
        OssFilterBar,
        ossCompanySelector,
        companyTable,
        MultipleFreeTagging,
        UploadDocumentsFromMail,
        OssWidgetEmbedder,
        Subscriptions,
        AccountingItemEdition2,
        TutorialButtonDialog,
        DocumentMultipleAnalysis,
        AuditCheckDocumentDialog,
        AuditCheckAlertButton,
    },
    emits: ["documentIdToDisplay", "addDocumentInList", "selectedDocuments", "validSelection"],
})
export class DocumentsTable extends Documents {
    importBankDialog: boolean = false;
    @Prop({ default: false }) selectMode: boolean;
    @Prop({ default: null }) actions: any;
    @Prop({ default: null }) preSelectedAuditCheckDocuments: any;
    @Prop({ default: null }) height: string;

    showTag: boolean = true;

    localEnv = env.environnement;

    widgetDialog = false;

    mobileDocumentDial = false;
    menuLoading = false;

    subscriptionsDialog = false;

    inGlobalStep = "";

    actionsMiscellaneousOperation = {
        action: new DialogAction(),
    };

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    get containerHeight() {
        return this.height || "calc(100vh - 64px)";
    }

    get documentTypes() {
        const types = [
            "ALL",
            "UNKNOWN",
            "QUOTATION",
            "SALES_INVOICE",
            "SALES_INVOICE_AUTO",
            "BANK_STATEMENT",
            "ZTILL_RECEIPT",
            "PURCHASE_INVOICE",
            "CURRENT_ACCOUNT",
            "OPERATOR_ACCOUNT",
            "PAY_SLIP",
        ];
        if (this.isAccountingUser) {
            types.push("MISCELLANEOUS_OPERATION");
            types.push("MISCELLANEOUS_SPLIT");
            types.push("CARRY_FORWARD");
            types.push("WITH_DELTA");
        }
        types.push(
            ...[
                "EXPENSE_REPORT",
                "EXPENSE_REPORT_DOCUMENT",
                "WITHOUT_INVOICE",
                "VAT",
                "MISCELLANEOUS",
                "BANK_CHARGE",
                "WAITING_CASHING",
                "MAIL",
                "SEPA",
                "SUBSCRIPTION",
                "LOAN",
                "LEASING",
                "SUBSCRIPTION_ACCOUNTING",
                "LOAN_ACCOUNTING",
                "LEASING_ACCOUNTING",
            ],
        );

        return types;
    }

    get allDocumentStatus() {
        // if (this.currentUser.profile.name.startsWith('geston')) {
        //     return [
        //         "ALL",
        //         "RECONCILIATION_DONE",
        //         "RECONCILIATION_MISSING",
        //         "INFORMATION_REQUEST",
        //         "DENIED",
        //         "PENDING",
        //         "DELETED"
        //     ]
        // }
        if (this.currentUser.profile.configuration.document.onlySelf) {
            return [
                // "ALL",
                "ORIGINAL_UPLOADED",
                "UPLOADED",
                "ANALYSED",
                "ANALYSED_OK",
                "VALIDATED",
                "ACCOUNTABLE_ACCOUNT_TO_DEFINE",
                "INFORMATION_REQUEST",
                "DENIED",
                "PENDING",
                "ERROR",
                "DELETED",
            ];
        }
        if (this.currentUser.profile.configuration.accounting.write) {
            return [
                // "ALL",
                "ORIGINAL_UPLOADED",
                "UPLOADED",
                "ANALYSED",
                "ANALYSED_OK",
                "VALIDATED",
                "ACCOUNTABLE_ACCOUNT_TO_DEFINE",
                "RECONCILIATION_DONE",
                "RECONCILIATION_MISSING",
                "INFORMATION_REQUEST",
                "DENIED",
                "PENDING",
                "ERROR",
                "DELETED",
            ];
        }
        return [
            // "ALL",
            "RECONCILIATION_DONE",
            "RECONCILIATION_MISSING",
            "INFORMATION_REQUEST",
            "DENIED",
            "PENDING",
            "DELETED",
        ];
    }

    get isAllSelected(): boolean {
        if (this.selectMode) {
            return (
                this.documents.length &&
                this.selectedAuditCheckDocuments.length === this.documents.length
            );
        }
        return this.documents.length && this.selectedDocumentIds.length === this.documents.length;
    }

    set isAllSelected(value) {
        if (this.selectMode) {
            this.selectedAuditCheckDocuments = value ? [...this.documents] : [];
        } else {
            this.selectedDocumentIds = value ? this.documents.map((d) => d.id) : [];
        }
    }

    get isIndeterminate(): boolean {
        if (this.selectMode) {
            return (
                this.selectedAuditCheckDocuments.length > 0 &&
                this.selectedAuditCheckDocuments.length < this.documents.length
            );
        }
        return (
            this.selectedDocumentIds.length > 0 &&
            this.selectedDocumentIds.length < this.documents.length
        );
    }

    initIfDocumentsRoute() {
        if (this.$route.query.orderBy) {
            const [value, descending] = (this.$route.query.orderBy as string).split("-");
            this.sortBy = { value, descending } as any;

            this.pagination.sortBy = [value];

            if (descending === "desc") {
                this.pagination.descending = [true];
            } else {
                this.pagination.descending = [false];
            }
        }
        this.defineFilter();
    }

    async beforeMount() {
        if (this.selectMode) {
            this.selectedAuditCheckDocuments = this.preSelectedAuditCheckDocuments;
            this.actions.action.display = true;
            this.actions.action.disabled = false;
            this.actions.action.title = "Valider";
            this.actions.action.function = this.validSelection;
        }

        this.query = DOCUMENTS_FILTER_QUERY;
        this.initIfDocumentsRoute();
        this.prevNext = {
            currentId: "",
            prevId: "",
            nextId: "",
        };
        await this.finishMounted();
    }

    async mounted(): Promise<void> {
        await this.initializeAuditCheckDocumentAlertAndDialog();
    }

    openBankImportMain() {
        this.importBankDialog = true;
        console.log(this.importBankDialog);
    }

    /**
     * Open the document wizard on loan step
     */
    openLoanWizard() {
        this.inGlobalStep = "loan";
        this.openDocumentWizard();
    }

    onbankTransactionImported() {
        throw new Error("Method not implemented.");
    }

    defineFilter() {
        if (this.$route.params.resetFilter || this.$route.query.resetFilter) {
            this.clearAllFilters();
        }
        if (this.$route.params.type) {
            const index = this.documentTypes.indexOf(this.$route.params.type as string);
            if (index !== -1) {
                this.documentType = this.documentTypes[index];
            }
            // this.filter.type = this.documentTypes.find(
            //     type => type === this.$route.params.type
            // );
        }
        if (this.$route.params.startDate) {
            this.filter.date.begin = this.$route.params.startDate;
        }
        if (this.$route.params.endDate) {
            this.filter.date.end = this.$route.params.endDate;
        }

        if (this.$route.params.status || this.$route.query.status) {
            const index = this.allDocumentStatus.indexOf(
                (this.$route.params.status as string) ||
                    (this.$route.query.status as string).toUpperCase(),
            );
            if (index !== -1) {
                this.documentStatus =
                    (this.$route.params.status as string) ||
                    (this.$route.query.status as string).toUpperCase();
            }
        }

        if (this.$route.params.auditCheck && !this.selectMode) {
            this.auditCheck = this.$route.params.auditCheck as string;
        }

        if (this.$route.query.auditCheck && !this.selectMode) {
            this.auditCheck = this.$route.query.auditCheck as string;

            // We empty the query from the router history to avoid back navigation and refresh issues
            this.$router.replace({ path: this.$route.path, query: {} });
        }

        if (this.$route.params.thirdPartyCompanyName) {
            this.thirdPartyCompanyName = this.$route.params.thirdPartyCompanyName as string;
        }
    }

    @Apollo({
        query: ACCOUNTING_LINES,
        variables() {
            return getCommonDocumentQueryFromALVariables(
                this.selectedCompany.id,
                this.selectedAccountingClosing,
                this.filter,
            );
        },
        skip() {
            return (
                this.auditCheck ||
                this.partitionTag ||
                this.filter.type === "MAIL" ||
                (this.filter.status !== "RECONCILIATION_MISSING" &&
                    this.filter.status !== "RECONCILIATION_DONE")
            );
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.accountingLines) {
                    this.accountingLines = data.accountingLines;
                    this.pagination.totalItems = data.accountingLineAggregate.count;
                    this.amountSum = data.accountingLineAggregate.amountSum;
                    this.firstRequestDone = true;
                    const documents = [];
                    for (const al of data.accountingLines) {
                        al.document.grossAmountSigned = al.amountSigned;
                        getChatStatus(this, al.document, al.document.chat);
                        this.computeReconciliationStatus(al.document);

                        documents.push(al.document);
                    }
                    this.dbDocuments = documents;
                } else {
                    this.accountingLines = [];
                }
            }
        },
    })
    accountingLines = [];

    @Apollo({
        query: MAILS_FILTER_QUERY,
        variables() {
            return getCommonMailQueryVariables(this.selectedCompany.id, this.filter);
        },
        skip() {
            return (
                !this.enableMail ||
                this.auditCheck ||
                this.partitionTag ||
                !this.selectedCompany ||
                !this.selectedCompany.id ||
                this.filter.type !== "MAIL"
            );
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                this.unsubscribe();
                this.accountingLines = [];
                this.dbDocuments = [];
                this.auditCheckDocumentItems = [];
                this.amountSum = 0;
                this.pagination.totalItems = 0;
                if (data && data.mails) {
                    this.pagination.totalItems = data.mailsConnection.aggregate.count;
                    this.amountSum = 0;
                    this.firstRequestDone = true;
                    this.mails = data.mails;
                } else {
                    this.mails = [];
                }
            }
        },
    })
    mails = [];

    get enableMail() {
        if (!this.currentUser?.profile?.type) {
            return false;
        }
        if (this.currentUser.profile.type === "ROOT") {
            return true;
        }
        if (this.currentUser.profile.type === "ACCOUNTING") {
            return true;
        }
        if (
            (this.currentUser.profile.type === "ACCOUNTING_CLIENT" ||
                this.currentUser.profile.type === "BUSINESS") &&
            this.currentUser.profile.restrictionLevel === 1
        ) {
            return true;
        }
        return false;
    }

    //
    //  BNC Autonome
    //

    bncOperationDialog: boolean = false;

    get isIncomingOutgoingPayment() {
        if (
            this.selectedCompany.profile &&
            this.selectedCompany.profile.accountingType === "INCOMING_OUTGOING_PAYMENT"
        ) {
            return true;
        }
        return false;
    }

    get isAutonomousUser() {
        return this.currentUser?.isAutonomousUser;
    }

    //
    // Mail
    //
    openMail(mail) {
        this.$router.push({
            name: "mail",
            params: {
                companyId: this.selectedCompany.id,
                id: mail.id,
            },
        });
    }

    //
    // Multi validation
    //

    multiValidationDialog: boolean = false;
    multiValidationLoading: boolean = false;

    get enableMultiValidation(): boolean {
        for (const d of this.documents) {
            if (d.status === "ANALYSED_OK") {
                return true;
            }
        }
        return false;
    }

    get onlyToValidateOKSelected() {
        const authorizedTypes = [
            "PURCHASE_INVOICE",
            "SALES_INVOICE",
            "EXPENSE_REPORT_DOCUMENT",
            "ZTILL_RECEIPT",
        ];
        return (
            this.selectedDocuments.length &&
            this.selectedDocuments.every(
                (d) =>
                    d.status === "ANALYSED_OK" &&
                    d.date &&
                    isInsideAccountingClosing(this.$store, d.date) &&
                    authorizedTypes.indexOf(d.type) !== -1,
            )
        );
    }

    isOnSuspenseAccount(document) {
        if (document.accountableAccount && document.accountableAccount.name) {
            if (
                document.accountableAccount.name !== "600000" &&
                document.accountableAccount.name !== "700000"
            ) {
                return false;
            }
        }
        const accountableAccountList = document.accountingLines.map(
            (al) => al.accountableAccount.name,
        );
        return accountableAccountList.find((acc) => acc === "600000" || acc === "700000");
    }

    async multiValidateDocuments() {
        this.multiValidationLoading = true;
        await this.$apollo.mutate({
            mutation: UPDATE_MANY_DOCUMENTS_STATUS,
            variables: {
                documentIds: this.selectedDocumentIds,
                status: "VALIDATED",
            },
        });
        this.selectedDocumentIds = [];
        this.multiValidationDialog = false;
        this.multiValidationLoading = false;
        this.refresh();
    }

    otherCompany(item) {
        if (item.thirdPartyCompany) {
            return item.thirdPartyCompany.name;
        }
        if (item.accountingCompany) {
            return item.accountingCompany.name;
        }
        return "";
    }

    @Watch("$route", { deep: true, immediate: true })
    filterDocumentsDescAscUpdate() {
        this.initIfDocumentsRoute();
    }

    // fileIcon(item) {
    //     return !!item.original ? "$oss-file" : ""
    // }

    // fileIconTooltip(item) {
    //     return !!item.original ? "Un fichier est relié à cette facture" : "Aucun fichier n'est relié à cette facture"
    documentInZtillReceipt(item) {
        return !!item?.isDocOfZTillReceipt?.originalDocument?.original?.id;
    }

    imported() {
        this.activeSaleInvoices = false;
        this.refresh();
    }

    displayDocumentBeforeSelect(document) {
        this.$emit("documentIdToDisplay", document);
    }

    validSelection() {
        this.$emit("validSelection");
    }

    addDocumentInList(document) {
        this.$emit("addDocumentInList", document);
    }

    startTuto() {
        emitter.$emit("setTutorialData", [
            {
                ref: document.getElementById("AddDocumentBtn"),
                title: "Créer un nouvel utilisateur",
                pages: [
                    {
                        ref: "AddDocumentBtn",
                        text: "Pour ajouter un utilisateur cliquez ici ",
                        position: "top",
                        align: "center",
                    },
                ],
            },
            {
                ref: document.getElementById("ODOptionAddDocument"),
                title: "Créer un nouvel utilisateur",
                pages: [
                    {
                        ref: "ODOptionAddDocument",
                        text: "Renseignez les informations demandés puis activez le compte si vous souhaitez que cette utilisateur puisse se connecter sur bobbee en renseignant le mail de connexion ainsi que son mot de passe. Vous devez également indiquer le « profil utilisateur » qui permet de définir les droits d’acces aux différentes fonctionnalités ",
                        position: "top",
                        align: "center",
                        isDialog: true,
                        before: {
                            clicks: ["AddDocumentBtn"],
                        },
                    },
                ],
            },
            {
                ref: document.getElementById("CreateJustificatoryDocument"),
                title: "Créer un nouvel utilisateur",
                pages: [
                    {
                        ref: "CreateJustificatoryDocument",
                        text: "Test du dialog ",
                        position: "top",
                        align: "center",
                        isDialog: true,
                        before: {
                            clicks: ["ODOptionAddDocument"],
                        },
                    },
                ],
            },
            {
                ref: document.getElementById("CreationOfDocument"),
                title: "Créer un nouvel utilisateur",
                pages: [
                    {
                        ref: "CreationOfDocument",
                        text: "Test du dialog dans facture",
                        position: "top",
                        align: "center",
                        isDialog: true,
                        before: {
                            clicks: ["CreateJustificatoryDocument"],
                        },
                    },
                ],
            },
            {
                ref: document.getElementById("CreateDevisDocument"),
                title: "Créer un nouvel utilisateur",
                pages: [
                    {
                        ref: "CreateDevisDocument",
                        text: "Rajout du titre et des informations",
                        position: "top",
                        align: "center",
                        isDialog: true,
                        before: {
                            clicks: ["CreationOfDocument"],
                        },
                    },
                ],
            },
        ]);
    }

    get labelTextColor() {
        return colors.grey.darken2;
    }

    checkMaximumPage() {
        debugger;
        const totalPage = Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage);
        if (this.pagination.page > totalPage) {
            this.pagination.page = totalPage;
        }
    }

    activeExtension = {
        name: "",
    };

    @Apollo({
        query() {
            return EXTENSIONS_LIST;
        },
        variables() {
            return {
                type: "DIALOG",
                displayIn: "DOCUMENTS_TABLE",
            };
        },
        skip() {
            return !this.selectedCompany?.id;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading && data) {
                this.extensionsDialog = data.getExtensions;
            }
        },
    })
    extensionsDialog = [];

    // documents multiple analysis
    get documentMultipleAnaysisPossible() {
        const acceptedTypes = ["ORIGINAL_UPLOADED", "UPLOADED", "ANALYSED"];
        return (
            this.selectedDocuments.length &&
            this.selectedDocuments.every((document) => acceptedTypes.includes(document?.status))
        );
    }

    // #region AUDIT CHECK DOCUMENTS

    auditCheckDocumentDoublonRefetchCount = 0;
    auditCheckDocumentsWithAnomaly: AuditCheckDocumentResult[] = [];
    selectedAuditCheckDocuments: Array<any> = [];
    shouldAuditCheckDocumentDialogBeVisible = false;

    /**
     * Count of audit check documents with anomalies (no date, duplicated...).
     */
    get auditCheckDocumentsWithAnomalyCount() {
        return this.auditCheckDocumentsWithAnomaly.reduce(
            (acc, checkDocument) => acc + checkDocument.count,
            0,
        );
    }

    get isAuditCheckDocumentDoublon() {
        return this.auditCheck === AuditCheckDocumentName.CheckDocumentDoublon;
    }

    /**
     * Show the action to hide or show ignored duplicates only when the audit check
     * control on "doublon" is active.
     */
    get showActionHideOrShowIgnoredDuplicates() {
        return !this.selectMode && this.isAuditCheckDocumentDoublon && this.documents?.length > 0;
    }

    get showActionIgnoreDuplicates() {
        return (
            !this.selectMode &&
            this.isAuditCheckDocumentDoublon &&
            this.documents &&
            this.selectedDocumentIds?.length > 1
        );
    }

    get isActionIgnoreDuplicatesEnabled() {
        return this.selectedDocuments?.some(
            (doc) => this.getAuditCheckResultDoublon(doc)?.status !== "IGNORE",
        );
    }

    addSelectedAuditCheckDocument(document) {
        if (this.isAuditCheckDocumentSelected(document.id)) {
            this.selectedAuditCheckDocuments = this.selectedAuditCheckDocuments.filter(
                (x) => x.id !== document.id,
            );
        } else {
            this.selectedAuditCheckDocuments.push(document);
        }
        this.emitSelectedDocuments();
    }

    emitSelectedDocuments() {
        this.$emit("selectedDocuments", this.selectedAuditCheckDocuments);
    }

    /**
     * Use the audit check result to ignore the selected duplicated documents
     * if they are not already ignored.
     */
    async ignoreSelectedDuplicatedDocuments() {
        const auditCheckResultCreatedOrUpdatedCount = { count: 0 };

        for (const document of this.selectedDocuments) {
            const existingAuditCheckResult = this.getAuditCheckResultDoublon(document);

            auditCheckResultCreatedOrUpdatedCount.count += await upsertAuditCheckResultIfNeeded(
                this.$apollo,
                existingAuditCheckResult,
                this.getAuditCheckDoublonResultKey(document.id),
                AuditCheckDocumentKey.CheckDocumentDoublon,
                document.id,
                this.selectedCompany.id,
                "IGNORE",
            );
        }

        if (auditCheckResultCreatedOrUpdatedCount.count > 0) {
            this.selectedDocumentIds = [];
            this.$apollo.queries.auditCheckDocumentItems.refetch();
            this.auditCheckDocumentDoublonRefetchCount++;
        }
    }

    /**
     * Returns the audit check doublon result for the given document.
     */
    getAuditCheckResultDoublon(document: any) {
        return document.auditCheckResults?.find(
            (acr) => acr.key === this.getAuditCheckDoublonResultKey(document.id),
        );
    }

    /**
     * Returns the key of the audit check doublon result for the given document.
     */
    getAuditCheckDoublonResultKey(documentId: string) {
        return `${AuditCheckDocumentKey.CheckDocumentDoublon}_${this.selectedCompany.id}_${documentId}`;
    }

    /**
     * Fetches the audit check documents for the selected company and stores them in the component's state
     * to be used in the audit check document alert and dialog components.
     */
    async initializeAuditCheckDocumentAlertAndDialog(): Promise<void> {
        // Setting an array to empty allows the view to update instantly. We don't want to retain the old value during the execution of the request.
        this.auditCheckDocumentsWithAnomaly = [];
        this.auditCheckDocumentsWithAnomaly = await getAuditCheckDocuments(
            this.$apollo,
            this.selectedCompany.id,
        );
    }

    isAuditCheckDocumentSelected(id) {
        return this.selectedAuditCheckDocuments?.findIndex((x) => x.id === id) !== -1;
    }

    onAuditCheckAlertButtonClicked(): void {
        this.shouldAuditCheckDocumentDialogBeVisible = true;
    }

    /**
     * Toggle the visibility of ignored audit check documents
     */
    toggleShowIgnoredAuditChecks() {
        this.selectedDocumentIds = [];
        this.showIgnoredAuditChecks = !this.showIgnoredAuditChecks;
    }

    /**
     * When the selected company changes or when audit check document doublons is refetched,
     * we need to reinitialize the audit check document data.
     */
    @Watch("auditCheckDocumentDoublonRefetchCount")
    @Watch("selectedCompany.id")
    async onChangesUpdateAuditCheckDocumentAlertData(): Promise<void> {
        await this.initializeAuditCheckDocumentAlertAndDialog();
    }

    // #endregion AUDIT CHECK DOCUMENTS
}

export default toNative(DocumentsTable);
</script>
<style scoped lang="scss">
div.filter-layout {
    margin-left: 15px !important;
}

.tag {
    border-radius: 30px;
    padding: 5px 10px;
    overflow: hidden;
    color: #fff;
    font-weight: bold;
    font-size: 15px;
}

.sell {
    background-color: #f3a683;

    &::after {
        content: "V";
    }
}

.buy {
    background-color: #63cdda;

    &::after {
        content: "A";
    }
}

.social {
    background-color: #cf6a87;

    &::after {
        content: "S";
    }
}

.ztill {
    background-color: #596275;

    &::after {
        content: "Z";
    }
}

.expenseReport {
    background-color: #63cdda;

    &::after {
        content: "N";
    }
}

.mobile {
    min-width: 100px;
    max-width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.redAmount {
    color: red;
}

::v-deep(.v-input) {
    font-size: 0.875rem;
}
</style>
